import Modal from './Modal';
import Body from './Body';
import Header from './Header';
import Footer from './Footer';
import styles from './styles.css';

export { Modal, styles, Body, Footer, Header }